import { CommonUtilities } from '../../commonUtils';

export default class ReportsServices {

    static globalSearch(param: any) {
        var url = 'metadata/globalSearch/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static ReportListing(data: any, type: any) {
        var url = 'reports/' + type + '?' + CommonUtilities.buildQueryString(data, true, true);;
        return CommonUtilities.getData(url);
    }

    static ReportListExport(data: any, fileName: any) {
        var url = 'affiliate/royaltyanalysis/Export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', fileName);
    }

    static ReportMenu() {
        var url = 'reports/type9?isReportMenu=true';
        return CommonUtilities.getData(url);
    }

    static ExistingReferences() {
        var url = 'contract/processReference/reporting?pageNumber=1&pageSize=10&';
        return CommonUtilities.getData(url);
    }

    static deleteReferences(data: any) {
        var url = 'contract/processReference/deleteProcessReference?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.deleteData(url);
    }

    static deleteProcessReference(data: any) {
        var url = 'contract/processReference/delete/' + data;
        return CommonUtilities.deleteData(url);
    }

    static AddedTransactions(data: any) {
        var url = 'contract/processReference/reporting/invoices?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static periodCount() {
        var url = 'common/periodCount';
        return CommonUtilities.getData(url);
    }

    static generate(period: any) {
        var url = 'affiliate/reportingPack/generate?periodNum=' + period;
        return CommonUtilities.getData(url);
    }

    static saveReport(param: any) {
        var url = 'reports/saveReport';
        return CommonUtilities.postData(url, param);
    }

    static processReferenceSave(param: any) {
        var url = 'contract/processReference/save';
        return CommonUtilities.postData(url, param);
    }

    static exportReport() {
        var url = 'affiliate/royaltyanalysis/Export?type=014&periodNum=20240331';
        return CommonUtilities.getData(url);
    }

    static generateArchive(param: any) {
        var url = 'reportingPack/generateArchive?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static ReportingPack_Export(param: any,fileName :any) {
        var url = 'affiliate/ReportingPack/Export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', fileName);
    }

}